/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAssetUrlRequest } from '../models/GetAssetUrlRequest';
import type { GetAssetUrlResponse } from '../models/GetAssetUrlResponse';
import type { UploadFileResponse } from '../models/UploadFileResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UploadApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Upload file
   * @param formData
   * @returns UploadFileResponse Uploaded file
   * @throws ApiError
   */
  public uploadFile(
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<UploadFileResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/assets',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get file url
   * @param requestBody
   * @returns GetAssetUrlResponse Asset file url
   * @throws ApiError
   */
  public getFileUrl(
    requestBody?: GetAssetUrlRequest,
  ): CancelablePromise<GetAssetUrlResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/assets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
